// extracted by mini-css-extract-plugin
module.exports = {"floors_title":"RestaurantList_floors_title__6_wje","floors_wrapp_item":"RestaurantList_floors_wrapp_item__L3jFS","item":"RestaurantList_item__1Dsez"};